import { render, staticRenderFns } from "./attachment_files.vue?vue&type=template&id=1723ccee&scoped=true&"
import script from "./attachment_files.vue?vue&type=script&lang=js&"
export * from "./attachment_files.vue?vue&type=script&lang=js&"
import style0 from "./attachment_files.vue?vue&type=style&index=0&id=1723ccee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723ccee",
  null
  
)

export default component.exports